import { findParentSelectedCollection } from '../dataGroup/innerComponents';
import { fieldTraitProgressBarOptions, fieldTraitTextContentOptions } from '../dataGroup/traitsApi';
import { marketplaceType } from './consts';

export default async function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pfx, classPfx, projectId, collections } = opts;
  domc.addType('marketplace-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          projectId: projectId,
          resizable: true,
          traits: [
            {
              type: 'select',
              label: 'Name Field',
              name: 'namefield',
            },
            {
              type: 'select',
              label: 'Description Field',
              name: 'descriptionfield',
            },
            {
              type: 'select',
              label: 'Quantity Field',
              name: 'quantityfield',
            },
            {
              type: 'select',
              label: 'Price Field',
              name: 'pricefield',
            },
          ],
        },
        async init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) {
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(selectedCollection);
            const textTraitsOptions = await fieldTraitTextContentOptions(
              selectedCollection,
              collections,
            );
            console.log('textTraitsOptions marketplace:>> ', textTraitsOptions);
            this.getTrait('namefield').set({
              options: textTraitsOptions,
            });
            this.getTrait('descriptionfield').set({
              options: textTraitsOptions,
            });
            this.getTrait('quantityfield').set({
              options: numberFieldTraitsOptions,
            });
            this.getTrait('pricefield').set({
              options: numberFieldTraitsOptions,
            });
          }
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'marketplace-form') {
            return {
              type: 'marketplace-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
}
